var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"margin-top":"80px","font-size":"24px","font-weight":"600"}},[_vm._v(" OA 单点登录中 ")]),_c('a-spin',{staticStyle:{"margin-top":"80px"},attrs:{"size":"large","spinning":_vm.spinning}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }